import { z } from "zod";
export { RegenerationReason } from "./analysis";
// Re-export existing call types from call.ts for backward compatibility
export * from "./call";
// Extended CallData schema for dashboard/UI consumption
// This extends the basic Call schema with additional UI-specific properties
export const CallDataSchema = z
    .object({
    id: z.string(),
    title: z.string(),
    description: z.string().optional(),
    summary: z.string().nullable(),
    startTime: z.string(), // ISO string
    endTime: z.string(), // ISO string
    callEndedAt: z.string().nullable(),
    duration: z.number().nullable(),
    meetingUrl: z.string().nullable(),
    status: z.string(),
    recallBotId: z.string().nullable(),
    hasRecordingStarted: z.boolean(),
    callType: z.string(),
    platform: z.string(),
    createdAt: z.string(),
    originatingCalendarEventId: z.string().nullable(),
    calendarEvent: z
        .object({
        id: z.string(),
        summary: z.string(),
        description: z.string().optional(),
    })
        .optional(),
})
    .passthrough(); // Allow additional properties for flexibility
// Calls API response schema
export const CallsResponseSchema = z.object({
    calls: z.array(CallDataSchema).optional(),
    total: z.number().optional(),
    approach: z.string().optional(),
    debug: z
        .object({
        userId: z.string().optional(),
        orgId: z.string().optional(),
        query: z.unknown().optional(),
    })
        .optional(),
});
